import repository from 'client/repository';
import alertActions from 'areas/alert/actions';
import swipeTypes from 'areas/swipes/domain/swipeTypes';

import {
    requestManualLookup,
    receiveManualLookup,
    requestManualLookupFailed,
    showManualLookupDialog,
    hideManualLookupDialog,
    showMultipleMatchesDialog
} from '../actions';

import progressActions from 'areas/progress/actions';

import {
    requestCardData,
    receiveCardData,
    showCardholderPage,
    showJobRoleSelectionPage
} from 'areas/cards/actions';

import m from 'messages';

/*
 * This is the action that gets performed when a person is looked up by their personal details rather than the QR code
 */
export default function (surname, initial, dob, cardNumber, context, isSpotCheck, siteCode) {

    const actionPrefix = 'MANUAL_LOOKUP';

    function failure(error) {
        return { type: `${actionPrefix}_FAILURE`, error };
    }

    return async dispatch => {
        try {

            dispatch(progressActions.report(m.cards.lookingUpPerson));
            dispatch(requestManualLookup(surname, initial, dob, cardNumber));

            const matches = await repository.data.manualLookup(surname, initial, dob, cardNumber);

            if (matches && matches.length === 1) {

                dispatch(progressActions.report(m.cards.matchFound));

                const match = matches[0];

                dispatch(receiveManualLookup(match))

                // Signal and do the load of the card data
                dispatch(requestCardData(match.qrCode));
                dispatch(progressActions.report(m.cards.fetchingCard));

                const qrData = await repository.cards.getCardDataByQR(match.qrCode, true, true, siteCode);
                qrData.cardData.swipeType = swipeTypes.Manual;
                qrData.cardData.dateRetrieved = new Date().toISOString();

                // Signal the card data has been received
                dispatch(receiveCardData(match.qrCode, qrData));

                dispatch(hideManualLookupDialog());

                if (isSpotCheck) {
                    dispatch(showJobRoleSelectionPage(match.qrCode, context));
                } else {
                    dispatch(showCardholderPage(match.qrCode, context));
                }

                dispatch(progressActions.hide());
            } else if (matches && matches.length > 1) {

                dispatch(showMultipleMatchesDialog(matches, context));
                dispatch(progressActions.hide());

            } else {
                dispatch(requestManualLookupFailed(m.cards.noMatchFound));
                dispatch(progressActions.hide());
                dispatch(alertActions.warn(m.cards.noMatchFoundWarning));
                dispatch(showManualLookupDialog());
            }
        }
        catch (error) {
            // Generic error handler, a number of different errors could have happened here
            dispatch(alertActions.error(error.failureReason || error.toString()));
            dispatch(failure(error.failureReason || error.toString()));
            dispatch(progressActions.hide());
            dispatch(showManualLookupDialog());
        }
    };
}
